import { render } from "./IconBurger.vue?vue&type=template&id=f315d8a2"
import script from "./IconBurger.vue?vue&type=script&lang=js"
export * from "./IconBurger.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__